import React from 'react'
import { ModalMessageProps } from '../types'

const ModalMessage: React.FC <ModalMessageProps> = ({ message }) => {

    return <div className = "modalBoxMainMessageContainer"><span>{message}</span></div>

}

export default ModalMessage